export default "__VITE_ASSET__c4186cde__"